<app-table
  [columns]="columns"
  [getDataCallback]="getData"
  [suppressFetch]="suppressFetch"
  #table
  class="table-recent-transactions"
  emptyMessage="Your recent transactions will appear here.">
  <ng-template
    #dateCell
    let-value="value">
    {{ value | date: 'dd/MM/yyyy' }}<br />
    <span class="small text-black-50">{{ value | date: 'hh:mm a' }}</span>
  </ng-template>
  <ng-template
    #descriptionCell
    let-value="value">
    {{ value }}
  </ng-template>
  <ng-template
    #amountCell
    let-row="row"
    let-value="value">
    <span
      class="fw-semibold"
      [class.opacity-50]="row.custom_amount">
      {{ value | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
    </span>
  </ng-template>
  <ng-template
    #statusCell
    let-value="value">
    <app-status-badge
      [value]="value"
      [department]="statusBadgeDepartments.TRANSACTIONS">
    </app-status-badge>
  </ng-template>
</app-table>
